import React from 'react';
import styled from 'styled-components';

const ThumbnailWrapper = styled.div`
    min-height: 200px;
    width: auto;
    align-items: center;
    justify-content: center;
    border-radius: 16px 16px 0 0;
    background: ${({backgroundTop}) => backgroundTop};
    /* padding: 16px; */
    overflow: hidden;
    display: flex;
    img {
        width: auto;
        max-width: 300px;
        max-height: 150px;
        border-radius: 16px;
        box-shadow: ${({shadow}) => shadow};
    }
`;

export const Thumbnail = ({ shadow, backgroundTop, src }) => (
  <ThumbnailWrapper shadow={shadow} backgroundTop={backgroundTop} >
    <img src={src} alt="attached image" />
  </ThumbnailWrapper>
);



// WEBPACK FOOTER //
// ./src/components/Card/Thumbnail.js